import {
  FC, memo, useCallback,
} from 'react';
import { createUseStyles } from 'react-jss';
import cn from 'classnames';

interface SortProps {
  className?: string,
  disabled?: boolean,
  items: {
    alias: string,
    label: string,
  }[],
  value: string,
  onChange?: (alias: string) => void,
}

const Sort: FC<SortProps> = (props) => {
  const {
    className,
    disabled,
    items,
    value,
    onChange,
  } = props;

  const classes = useStyles();

  const handleChange = useCallback((alias: string) => {
    onChange?.(alias);
  }, [onChange]);

  return (
    <div className={cn(className, classes.container, { disabled })}>
      {items.map((item) => (
        <button
          className={cn({ selected: item.alias === value ? 'selected' : undefined })}
          key={item.alias}
          onClick={handleChange.bind(null, item.alias)}
          type="button"
          disabled={disabled}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    '&': {
      display: 'flex',
    },
    '& button': {
      '&': {
        border: '1px solid #aaaaaa',
        borderRadius: '0.4rem',
        fontSize: '1.2rem',
        lineHeight: '1rem',
        textAlign: 'center',
        fontWeight: 400,
        padding: '0.5rem 1.5rem 0.4rem',
        background: 'transparent',
        color: '#585858',
        transition: '300ms background ease, 300ms color ease, 300ms border-color ease',
        cursor: 'pointer',
        marginLeft: '1.2rem',
      },
      '&:first-child': {
        marginLeft: 0,
      },
      '@media (min-width: 375px)': {
        fontSize: '1.4rem',
        lineHeight: '1.4rem',
      },
    },
    '& button.selected': {
      background: '#39C4BD',
      color: '#ffffff',
      borderColor: '#39C4BD',
      transitionDuration: '300ms',
    },
    '& button[disabled], & button.selected[disabled]': {
      background: '#f5f5f5',
      color: '#868686',
      borderColor: '#aaaaaa',
      pointerEvents: 'none',
    },
  },
});

export default memo(Sort);
